import React from 'react'
import { Outlet } from 'react-router-dom'

export const AuthenticationLayout = () => {
  return (
    <main>
      <Outlet />
    </main>
  )
}
